<nb-card class="convert-project-dialog">
  <nb-card-header>
    <h1>{{ 'crm.convert.title' | translate }}</h1>
  </nb-card-header>

  <nb-card-body>
    <p class="body-copy">
      {{ 'crm.convert.body' | translate:{ name: consultantName, opp: opportunityTitle } }}
    </p>

    <div class="date-row">
      <div class="date-field">
        <label class="field-label">{{ 'crm.convert.start_label' | translate }}</label>
        <input nbInput fullWidth
               [placeholder]="'crm.convert.start_label' | translate"
               [(ngModel)]="start"
               [nbDatepicker]="startPicker">
        <nb-datepicker #startPicker></nb-datepicker>
      </div>
      <div class="date-field">
        <label class="field-label">{{ 'crm.convert.end_label' | translate }}</label>
        <input nbInput fullWidth
               [placeholder]="'crm.convert.end_label' | translate"
               [(ngModel)]="end"
               [nbDatepicker]="endPicker">
        <nb-datepicker #endPicker></nb-datepicker>
      </div>
    </div>

    <div class="error-banner" *ngIf="errorKey">
      {{ errorKey | translate }}
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton type="button" ghost (click)="skip()" [disabled]="saving">
      {{ 'crm.convert.skip' | translate }}
    </button>
    <button nbButton type="button" status="primary" (click)="create()" [disabled]="saving">
      <nb-spinner *ngIf="saving" size="tiny"></nb-spinner>
      {{ 'crm.convert.create' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
